import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetPasswordComponent } from './reset-password.component';
import { LibModule } from '@ui-components/lib.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ResetPasswordComponent
  ],
  imports: [
    CommonModule,
    LibModule,
    ReactiveFormsModule
  ]
})
export class ResetPasswordModule { }
